import paymentMethod from './lib/paymentMethod';

export default paymentMethod;
